// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { ifObjectGetValue } from 'helpers/reduxFormFunctions'

// in the ui, we handle ACM radios by grouping all their modulations into a tooltip,
// just like on project summary view. to make the exported data meaningful,
// each row of the CSV data will represent a unique radio & modulation pair.
// in this function, the results data (one radio per row) is transformed
// so that every modulation has its own row.
const scrubForCSV = results => (
  results.reduce((a, d, i) => {
    // radio level data which we want to permeate the modulation data rows.
    const {
      architecture,
      companyName,
      frequency,
      powerType,
      radioCode,
      radioFamilyName,
      modulations,
      specDate,
      status,
    } = d

    modulations.forEach(m => {
      const {
        bandwidth,
        modelNumber,
        modulationDescription,
        modulationScheme,
        rxThreshold,
        throughput,
        txPowerMax,
      } = m

      let modelNumberConcatenated = modelNumber
      if (powerType) {
        modelNumberConcatenated += ` ${powerType}`
      }
      if (architecture) {
        modelNumberConcatenated += ` ${architecture.architecture}`
      }

      const modulationSchemeDescription = ifObjectGetValue(modulationScheme, 'modulationSchemeDescription')

      const n = {
        bandwidth,
        companyName,
        frequency,
        modelNumberConcatenated,
        modulationDescription,
        modulationSchemeDescription,
        radioCode,
        radioFamilyName,
        // naming is wonky because in UI modulations maps to an array of modulations
        // and create2dArrayOfResults only knows how to map objects by
        // the keys identified in the columns array
        modulations: throughput,
        rxThreshold,
        specDate,
        status,
        txPowerMax,
      }
      a.push(n)
    })
    return a
  }, [])
)

export default scrubForCSV
